module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAL5JREFUWEft1M0NwjAMBWBnAabICSVDMEQ7BfMwBCzBDnE4ZQoGiJElKlWI/Bzi9OJcevP7+urGwMHHHJwPCtAGtAFtoLsBa+0ppfQefXF1AZxzd2PMOee8xhhfIxFNgGQ4v0gVIB1eBcwILwK2cCK6jvze+1mI+PwL4HAAWKSCv3MvRYD3fiEiRjwA4CYFKQI4cI9AxFUKUV3CWYjqbzgD0byIpBFNwLYT/Awh8GIOPV2AoYk/wxSgDWgD2sAHxZNeIY9/LVYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/left.png
// module id = e/LX
// module chunks = 0